import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Tooltip } from 'primereact/tooltip';
import {
    FaBook,
    FaBriefcase,
    FaClock,
    FaCog,
    FaDollarSign,
    FaExclamationCircle,
    FaExclamationTriangle,
    FaFileExcel,
    FaFilePdf,
    FaUpload,
    FaWallet
} from 'react-icons/fa';
import { CalendarPague, DropdownPague } from '../../../../styles/primeReactConfig';

import { addLocale, locale } from 'primereact/api';

import { Link } from 'react-router-dom';
import AppCard from '../../../../components/appCard';
import FAQAdimplenciaDialog from '../../../../components/dashboard/adimplencias/FAQAdimplencia.js';
import { useInfo } from '../../../../context/infoContext';
import { ApiAdimplencia } from '../../../../services/api';
import { formatCurrency } from '../../../../utils/formatCurrency';
import GeraXLSX from '../../../../utils/GeraXLSX';

export default function PainelAdimplencia() {

    const { credorData } = useInfo();

    const [dashboardAdimplencia, setDashboardAdimplencia] = useState([0, 0, 0, 0]);

    const [diaInicial, setDiaInicial] = useState(null);
    const [diaFinal, setDiaFinal] = useState(null);
    const [infoAdimplencia, setInfoAdimplencia] = useState(false);
    const [status, setStatus] = useState("Todos");
    const [loadingRelatorio, setLoadingRelatorio] = useState(false);

    const statusOptionsAdimplencia = [
        { label: "Pago", value: "Pago" },
        { label: "Vencido", value: "Vencido" },
        { label: "Aguardando", value: "Aguardando" },
        { label: "Todos", value: "Todos" },
    ];

    addLocale('pt-BR', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
        dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
        today: 'Hoje',
        clear: 'Claro'
    });
    locale('pt-BR');

    useEffect(() => {
        getDashboardAdimplencia()
    }, [credorData])

    function formatarDataISO(date) {
        const d = new Date(date);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }

    async function gerarRelatorio(tipo) {
        if (!diaInicial || !diaFinal) {
            toast.error("Selecione o período (data inicial e final) para gerar o relatório.");
            return;
        }
        setLoadingRelatorio(true);
        try {
            const dataIni = formatarDataISO(diaInicial);
            const dataFim = formatarDataISO(diaFinal);
            const situacao = status || 'Todos';

            if (tipo === 'pdf') {
                const { data } = await ApiAdimplencia.get(
                    `/relatorio/adimplencia/${situacao}/${dataIni}/${dataFim}/pdf`,
                    { responseType: 'arraybuffer' }
                );
                const blob = new Blob([data], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `Relatorio_Adimplencia_${dataIni}_${dataFim}.pdf`;
                link.click();
                URL.revokeObjectURL(url);
            } else {
                const { data } = await ApiAdimplencia.get(
                    `/relatorio/adimplencia/${situacao}/${dataIni}/${dataFim}/excel`
                );
                GeraXLSX({
                    data: data.dados,
                    headers: ['Contrato', 'Nome', 'Beneficiário', 'Documento', 'Descrição', 'Vencimento', 'Valor', 'Desconto', 'Valor Pago', 'Data Pagamento', 'Situação', 'Repasse', 'Data Repasse'],
                    fields: ['contratante_numero', 'usuario_nome', 'beneficiario', 'usuario_documento', 'faturamento_descricao', 'boleto_vencimento', 'boleto_valor', 'faturamento_desconto', 'boleto_valor_pago', 'boleto_data_pagamento', 'boleto_situacao', 'valor_credor', 'data_repasse'],
                    titulo: data.relatorioNome || 'Relatorio_Adimplencia',
                });
            }
        } catch (err) {
            console.error(err);
            const mensagem = err?.response?.data?.mensagem || "Erro ao gerar relatório. Tente novamente.";
            toast.error(mensagem);
        } finally {
            setLoadingRelatorio(false);
        }
    }

    async function getDashboardAdimplencia() {
        try {
            const { data } = await ApiAdimplencia.get(`/dashboard`);
            setDashboardAdimplencia(data);
            return true;
        } catch (err) {
            console.log(err);
            toast.error("Erro de conexão com o servidor, tente novamente mais tarde!");
            return false;
        }
    }

    return (
        <>
            {infoAdimplencia && <FAQAdimplenciaDialog close={() => setInfoAdimplencia(false)} />}
            <div className='-mt-2 w-full flex flex-wrap'>
                <div className="flex flex-wrap w-full">
                    {dashboardAdimplencia[0] !== 0 && <div className="p-2 lg:w-1/4 md:w-1/2 w-full">
                        <AppCard className="overflow-x-auto">
                            <div className="flex justify-between w-full mb-2 gap-2" >
                                <Tooltip target=".pg" content="Todos os valores recebidos em função da Direto" position='right' />
                                <div className="text-xl">
                                    PAGO
                                </div>
                                <div className="flex justify-center items-center bg-emerald-300 text-emerald-900 h-10 w-10 p-3 rounded-md pg">
                                    <FaWallet />
                                </div>
                            </div>
                            <div className="flex align-items center justify-between">
                                <div className="text-xl">{formatCurrency(dashboardAdimplencia[0] !== 0 ? dashboardAdimplencia[0].boleto_valor : 0)}</div>
                                <div className="text-xs">{dashboardAdimplencia[0] !== 0 ? `(${dashboardAdimplencia[0].quantidade})` : `(${0})`}</div>
                            </div>
                        </AppCard>
                    </div>}
                    {dashboardAdimplencia[1] !== 0 && <div className="p-2 lg:w-1/4 md:w-1/2 w-full">
                        <AppCard className="overflow-x-auto">
                            <div className="flex justify-between w-full mb-2 gap-2" >
                                <Tooltip target=".agd" content="Boletos gerados e que ainda estão dentro do prazo de pagamento" position='right' />
                                <div className="text-xl">
                                    AGUARDANDO
                                </div>
                                <div className="flex justify-center items-center bg-cyan-300 text-cyan-900 h-10 w-10 p-3 rounded-md agd">
                                    <FaClock />
                                </div>
                            </div>
                            <div className="flex align-items center justify-between">
                                <div className="text-xl">{formatCurrency(dashboardAdimplencia[1] !== 0 ? dashboardAdimplencia[1].boleto_valor : 0)}</div>
                                <div className="text-xs">{dashboardAdimplencia[1] !== 0 ? `(${dashboardAdimplencia[1].quantidade})` : `(${0})`}</div>
                            </div>
                        </AppCard>
                    </div>}
                    {dashboardAdimplencia[2] !== 0 && <div className="p-2 lg:w-1/4 md:w-1/2 w-full">
                        <AppCard className="overflow-x-auto">
                            <div className="flex justify-between w-full mb-2 gap-2" >
                                <Tooltip target=".cnd" content="Boletos cancelados em função de uma nova emissão" position='right' />
                                <div className="text-xl">
                                    CANCELADO
                                </div>
                                <div className="flex justify-center items-center bg-purple-300 text-purple-900 h-10 w-10 p-3 rounded-md cnd">
                                    <FaExclamationTriangle />
                                </div>
                            </div>
                            <div className="flex align-items center justify-between">
                                <div className="text-xl">{formatCurrency(dashboardAdimplencia[2] !== 0 ? dashboardAdimplencia[2].boleto_valor : 0)}</div>
                                <div className="text-xs">{dashboardAdimplencia[2] !== 0 ? `(${dashboardAdimplencia[2].quantidade})` : `(${0})`}</div>
                            </div>
                        </AppCard>
                    </div>}
                    {dashboardAdimplencia[3] !== 0 && <div className="p-2 lg:w-1/4 md:w-1/2 w-full">
                        <AppCard className="overflow-x-auto">
                            <div className="flex justify-between w-full mb-2 gap-2" >
                                <Tooltip target=".vcd" content="Boletos que venceram e não foram pagos" position='left' />
                                <div className="text-xl">
                                    VENCIDO
                                </div>
                                <div className="flex justify-center items-center bg-red-300 text-red-900 h-10 w-10 p-3 rounded-md vcd">
                                    <FaDollarSign />
                                </div>
                            </div>
                            <div className="flex align-items center justify-between">
                                <div className="text-xl">{formatCurrency(dashboardAdimplencia[3] !== 0 ? dashboardAdimplencia[3].boleto_valor : 0)}</div>
                                <div className="text-xs">{dashboardAdimplencia[3] !== 0 ? `(${dashboardAdimplencia[3].quantidade})` : `(${0})`}</div>
                            </div>
                        </AppCard>
                    </div>}
                </div>
                <div className="flex flex-wrap w-full">
                    <div className='p-2 lg:w-1/2 w-full'>
                        <AppCard>
                            <div className="flex justify-between w-full mb-2" >
                                <Tooltip target=".ajd" content="Ajuda" position='bottom' />
                                <div className="grid">
                                    <span className="text-xl">DADOS DO BOLETO</span>
                                </div>
                                <Button
                                    tooltip='Ajuda'
                                    tooltipOptions={{ position: 'right' }}
                                    pt={{
                                        root: `border-0 items-center
                                          bg-blue-300 hover:bg-blue-400
                                          text-blue-700 hover:text-blue-900
                                          p-3 rounded-lg 
                                          transition duration-200 ease-in-out
                                          `,
                                        label: "absolute"
                                    }}
                                    icon={<FaExclamationCircle />}
                                    onClick={() => { setInfoAdimplencia(prev => !prev) }}
                                />
                            </div>
                            <div className="flex md:flex-row flex-col justify-between w-full gap-2">
                                <div className='flex flex-col gap-2 md:w-1/2 w-full'>
                                    <Link to="/dashboard/adimplencia/parametros">
                                        <Button
                                            label='Parâmetros'
                                            className='w-full'
                                            icon={<FaCog className='text-1xl text-white dark:text-black' />}
                                        />
                                    </Link>
                                    <Link to="/dashboard/adimplencia/importar">
                                        <Button
                                            className='w-full'
                                            label='Importação de Arquivo'
                                            icon={<FaUpload className='text-1xl text-white dark:text-black' />}
                                        />
                                    </Link>
                                </div>
                                <div className='flex flex-col gap-2 md:w-1/2 w-full'>
                                    <Link to="/dashboard/adimplencia/clientes">
                                        <Button
                                            label='Emissão de boleto'
                                            className='w-full'
                                            icon={<FaBriefcase className='text-1xl text-white dark:text-black' />}
                                        />
                                    </Link>
                                    <Link to="/dashboard/adimplencia/boletos">
                                        <Button
                                            label='Boletos gerados'
                                            className='w-full'
                                            icon={<FaDollarSign className='text-1xl text-white dark:text-black' />}
                                        />
                                    </Link>
                                </div>
                            </div>
                        </AppCard>
                    </div>
                    <div className='p-2 lg:w-1/2 w-full'>
                        <AppCard>
                            <div className="flex justify-between w-full mb-2" >
                                <Tooltip target=".ajd" content="Ajuda" position='bottom' />
                                <div className="grid">
                                    <span className="text-xl">RELATÓRIOS</span>
                                </div>
                                <div className="flex justify-center items-center bg-yellow-300 text-yellow-900 h-10 w-10 p-3 rounded-md">
                                    <FaBook />
                                </div>
                            </div>
                            <div className="flex flex-col w-full gap-2">
                                <div className='flex md:flex-row flex-col justify-between w-full gap-2'>
                                    <Calendar
                                        className='painelAdimplencia'
                                        value={diaInicial}
                                        maxDate={diaFinal}
                                        pt={CalendarPague}
                                        locale="pt-BR"
                                        dateFormat="dd/mm/yy"
                                        placeholder="Dia Inicial"
                                        mask="99/99/9999"
                                        yearRange="2020:2030"
                                        yearNavigator
                                        onChange={(e) => {
                                            setDiaInicial(e.value);
                                        }}
                                    />
                                    <Calendar
                                        className='painelAdimplencia'
                                        value={diaFinal}
                                        minDate={diaInicial}
                                        pt={CalendarPague}
                                        locale="pt-BR"
                                        dateFormat="dd/mm/yy"
                                        placeholder="Dia Final"
                                        mask="99/99/9999"
                                        yearRange="2020:2030"
                                        yearNavigator
                                        onChange={(e) => {
                                            setDiaFinal(e.value);
                                        }}
                                    />
                                </div>
                                <div className='flex lg:flex-row flex-col justify-between w-full gap-2'>
                                    <Dropdown
                                        className='painelAdimplencia'
                                        value={status}
                                        options={statusOptionsAdimplencia}
                                        pt={DropdownPague}
                                        onChange={(e) => setStatus(e.value)}
                                    />
                                    <div className='flex lg:w-1/2 w-full gap-2'>
                                        <Button
                                            className='w-1/2'
                                            label='Excel'
                                            severity='success'
                                            icon={<FaFileExcel className='text-1xl text-white dark:text-black' />}
                                            loading={loadingRelatorio}
                                            disabled={loadingRelatorio}
                                            onClick={() => gerarRelatorio('excel')}
                                        />
                                        <Button
                                            className='w-1/2 '
                                            label='PDF'
                                            severity='danger'
                                            icon={<FaFilePdf className='text-1xl text-white dark:text-black' />}
                                            loading={loadingRelatorio}
                                            disabled={loadingRelatorio}
                                            onClick={() => gerarRelatorio('pdf')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </AppCard>
                    </div>
                </div>
            </div>
        </>
    )
}